import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";

const numero = (valor) => Number(valor) || 0;

export const guardarConfiguracionArca = ({
  EmpresaId,
  UsuarioId,
  Cuit,
  ArchivoCertificado,
  PasswordCertificado,
  ActualizarPassword = true,
}, opciones) => _Componentes_WebApiCalls_Post("arca/configuracion/guardar", {
  EmpresaId: numero(EmpresaId),
  UsuarioId: numero(UsuarioId),
  Cuit: String(Cuit || "").trim(),
  ArchivoCertificado: String(ArchivoCertificado || "").trim(),
  PasswordCertificado: String(PasswordCertificado || ""),
  ActualizarPassword: Boolean(ActualizarPassword),
}, opciones);

export const validarConfiguracionArca = ({ EmpresaId, UsuarioId }, opciones) =>
  _Componentes_WebApiCalls_Post("arca/configuracion/validar", {
    EmpresaId: numero(EmpresaId),
    UsuarioId: numero(UsuarioId),
  }, opciones);

export const sincronizarNumeradoresArca = ({
  EmpresaId,
  UsuarioId,
  PuntoVenta,
  ComprobantesTipoIds,
}, opciones) => _Componentes_WebApiCalls_Post("arca/configuracion/sincronizar-numeradores", {
  EmpresaId: numero(EmpresaId),
  UsuarioId: numero(UsuarioId),
  PuntoVenta: numero(PuntoVenta),
  ComprobantesTipoIds: (Array.isArray(ComprobantesTipoIds) ? ComprobantesTipoIds : [])
    .map(numero)
    .filter((id) => id > 0),
}, opciones);

const leer = (objeto, nombre, respaldo) => objeto?.[nombre] ?? objeto?.[nombre.charAt(0).toLowerCase() + nombre.slice(1)] ?? respaldo;

export const normalizarValidacionArca = (datos = {}) => ({
  ambiente: String(leer(datos, "Ambiente", "")),
  configuracionGuardada: Boolean(leer(datos, "ConfiguracionGuardada", false)),
  certificadoValido: Boolean(leer(datos, "CertificadoValido", false)),
  wsaaAutenticado: Boolean(leer(datos, "WsaaAutenticado", false)),
  wsfeDisponible: Boolean(leer(datos, "WsfeDisponible", false)),
  consumidorFinalConfigurado: Boolean(leer(datos, "ConsumidorFinalConfigurado", false)),
  numeradoresConfigurados: Boolean(leer(datos, "NumeradoresConfigurados", false)),
  listoParaEmitir: Boolean(leer(datos, "ListoParaEmitir", false)),
  problemas: leer(datos, "Problemas", []) || [],
  numeradores: leer(datos, "Numeradores", []) || [],
});

export const extraerErrorApi = (respuesta, respaldo) =>
  respuesta?.error || respuesta?.data?.Error || respuesta?.data?.error || respaldo;
